module.exports = __webpack_public_path__ + "06_short_gray.5403ba3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/dad/layer5/06_short_gray.png
// module id = SUUx
// module chunks = 0